<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 pt-0 px-0">
        <div class="col-12 py-1 px-4">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold">
            Variables
          </h3>
          <div class="row">
            <div class="form-group col-12 col-md-8 mb-0 mb-md-4 px-0">
              <div class="d-flex align-items-end">
                <div class="w-50 pr-2">
                  <label for="">Búsqueda</label>
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="form-control form-control-sm mt-1 mb-2"
                    v-model="searchQuery"
                    @keyup="loadElements()"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive card">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">id</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Nombre</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Valor</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr
                  class=""
                  v-for="item in data"
                  :key="item.id"
                  style="cursor: pointer; height: 38px"
                >
                  <td class="text-center">{{ item.id }}</td>

                  <td class="text-center">
                    {{ item.name }}
                  </td>
                  <td class="text-center">
                    {{ item.value }}
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <Tooltip text="Editar">
                        <button
                          class="btn bg-warning border-0 mx-1 p-2"
                          @click="goEdit(item.id)"
                        >
                          <i
                            class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                  <td class="d-none"></td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in totalPages" :key="page">
                    <a
                      class="page-link"
                      :class="{
                        'bg-primary ': page == currentPage,
                        'text-white': page === currentPage
                      }"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      data: [],
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20
    }
  },
  methods: {
    ...mapActions(['getData', 'updateData']),

    async loadElements(page = 1) {
      const form = {
        url: 'config/all',
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit
        }
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.data = response.data.data.reverse()
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },

    async goEdit(id) {
      const currentValue = this.data.find((item) => item.id === id)
      const { value } = await Swal.fire({
        title: 'Modificar variable',
        input: 'text',
        inputLabel: `Nuevo valor para: ${currentValue.name}`,
        inputValue: currentValue.value,
        showCancelButton: true,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
          if (!value) {
            return 'Este campo no puede quedar vacío!'
          }
        }
      })

      if (value && value !== currentValue.value) {
        const result = await Swal.fire({
          title: '¿Está seguro?',
          text: '¿Desea modificar esta variable?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, modificarlo',
          cancelButtonText: 'Cancelar'
        })

        if (result.isConfirmed) {
          const form = {
            url: 'config/update',
            id,
            data: { value }
          }

          try {
            const response = await this.updateData(form)
            if (response.code === 200) {
              Swal.fire('¡Éxito!', 'La variable ha sido modificado.', 'success')
              this.loadElements()
            }
          } catch (error) {
            console.error(error)
            Swal.fire(
              'Error',
              'Ocurrió un error al modificar el maestro.',
              'error'
            )
          }
        }
      }
    }
  },
  mounted() {
    this.loadElements()
  }
}
</script>
